import { updateState } from 'app-webtech-core/reducers';
import { DEFAULT_TARGET } from './const';

const isEmptyArray = (value) => Array.isArray(value) && !value.length;

const withoutTarget = ({ targets }) => !targets || isEmptyArray(targets);

const commandFromTargetNames = (targetNames, event) =>
  targetNames.reduce((obj, targetName) => ({ ...obj, [targetName]: { $push: [event] } }), {});

const groupByTargets = (targetNames) => (aggregator, event) => {
  let command;
  if (withoutTarget(event)) {
    command = commandFromTargetNames([DEFAULT_TARGET], event);
  } else {
    const { targets } = event;

    switch (typeof targets) {
      case 'string':
        if (targetNames.includes(targets)) {
          command = { [targets]: { $push: [event] } };
        }
        break;
      case 'object':
        if (Array.isArray(targets)) {
          const availableTargets = targets.filter((target) => targetNames.includes(target));
          command = commandFromTargetNames(availableTargets, event);
        }
        break;
      default:
        break;
    }
  }

  return updateState(aggregator, command);
};

const getInitialState = (targetNames) =>
  targetNames.reduce((obj, targetName) => ({ ...obj, [targetName]: [] }), {});

export const multiTarget = (targetMap) => {
  const targetNames = Object.keys(targetMap);
  const loadedTargets = getInitialState(targetNames);
  return (events) => {
    if (targetNames.length) {
      const eventsByTarget = events.reduce(groupByTargets(targetNames), loadedTargets);

      targetNames.forEach((targetName) => {
        const target = targetMap[targetName];
        const targetEvents = eventsByTarget[targetName];

        if (!isEmptyArray(targetEvents)) {
          try {
            target(targetEvents);
          } catch (err) {
            console.error(err);
          }
        }
      });
    }
  };
};
